module.exports = require('./assign');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/object/extend.js
// module id = 578
// module chunks = 0